import React, { useEffect, useContext, useState, useRef } from "react";
import { TokenVerificationLoggedin, BlockOtherThanAdmin } from "../../utils/tokenVerify";
import { LoadingContext } from "react-router-loading";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../config/config.json";
import { Table, Tooltip, Select, Col, Row, Pagination, Input, Modal, Space, Switch } from 'antd';
import columnIcon from '../../assets/images/icons/column.svg'
import { Link } from 'react-router-dom'
import FullLoader from "../../assets/images/full-page-loader.gif"
import prevIcon from '../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../assets/images/icons/chevron-right.svg';
import { jwtDecode } from "jwt-decode";
import noData from '../../assets/images/data-graph/no-data.svg';
import TableLoader from "../TableLoader";
import errorData from '../../assets/images/data-graph/error-data.svg';
import Dropdown from 'react-bootstrap/Dropdown';
import imIcon from '../../assets/images/icons/skype.svg';
import telegramIcon from '../../assets/images/icons/telegram.svg';
import wechatIcon from '../../assets/images/icons/wechat.svg';
import AddUserIcon from '../../assets/newlayout/add_user_icon.svg';
import constantData from "../../constants/constantData.json";
import { notifysuccess } from "../../utils/toast";
import { notifyfailure } from "../../utils/toast";
import { notifycatch } from "../../utils/toast";
import loaderIcon from "../../assets/images/login-and-signup/loader.gif";

const { Option } = Select;

const PublisherUserList = () => {

    const loadingContext = useContext(LoadingContext);
    const [apiCall, setApicall] = useState(false)
    // const [colvis, setColvis] = useState({
    //     "z_cate": true,
    //     "invent_type": true,
    //     "p_name": true,
    //     "createdAt": true
    // })

    const columnsAll = [
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            width: 80,
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (text, record) =>
                <Switch checked={text} onChange={(event) => {
                    let status = Cookies.get("token_xapads_ssp") ? true : false;
                    if (status) {
                        let token = Cookies.get("token_xapads_ssp");

                        let payload = {
                            "status": event,
                            "id": record?.id
                        }


                        axios
                            .put(configData.SERVER_URL + `zone/statusUpdateUser123`, payload, {
                                headers: {
                                    "Content-Type": "application/json",
                                    "x-access-token": token,
                                },
                            })
                            .then((response) => {
                                setApicall(!apiCall)
                                notifysuccess(response.data.message);

                            })
                            .catch((error) => {
                                if (error?.response) {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message)
                                    }
                                } else {
                                    notifycatch()
                                }
                            });

                    }
                }} />

        },
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            width: 150,
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
        // {
        //     title: "Role",
        //     dataIndex: "Role",
        //     width: 200,
        //     key: "Role",
        //     // hidden: !colvis["z_cate"],
        //     sortDirections: ['ascend', 'descend', 'ascend'],
        //     sorter: true,
        //     render: (text) => {
        //         return (
        //             <>
        //                 <div className="usertable_badges_d2">
        //                     <div className={`table_badges--d2 --${text === "mobops" ? "blue" : text === "sa" ? "green" : "pink"}`}>
        //                         {text === "mobops" ? "Mobile Ops" : text === "sa" ? "Super Admin" : text === "am" ? "AM" : text}
        //                     </div>
        //                 </div>
        //             </>
        //         )
        //     }
        // },
        // {
        //     title: "Organization Name",
        //     dataIndex: "Organization Name",
        //     width: 300,
        //     key: "Organization Name",
        //     sortDirections: ['ascend', 'descend', 'ascend'],
        //     sorter: true,
        // },
        {
            title: "Email",
            dataIndex: "email",
            width: 250,
            key: "email",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
        // {
        //     title: "Website",
        //     dataIndex: "Website",
        //     width: 200,
        //     key: "Website",
        //     sortDirections: ['ascend', 'descend', 'ascend'],
        //     sorter: true,
        //     render: (data) => <Link style={{ textDecoration: "none", cursor: "default" }} className='text_primary' >{data}</Link>,
        // },
        {
            title: "IM",
            dataIndex: "IM",
            width: 200,
            key: "IM.value",
            sortDirections: ['ascend', 'descend', 'ascend'],
            // hidden: !colvis["IM"],
            render: (text) => <div className='im_type text_dark'>
                {text?.label === "telegram" ?
                    <img src={telegramIcon} alt='USP' /> :
                    text?.label === "wechat" ?
                        <img src={wechatIcon} alt='USP' /> :
                        <img src={imIcon} alt='USP' />
                }
                {text?.value}</div>
        },
        {
            title: "Created At",
            dataIndex: "createdAt",
            // width: 200,
            key: "createdAt",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
    ];

    const [data, setData] = useState([
        {
            id: "1",
            status: true,
            name: "Jack",
            email: "jack@gmail.com",
            IM: {
                "label": "telegram",
                "value": "NA"
            },
            createdAt: "24 July, 2026"
        },
        {
            id: "1",
            status: true,
            name: "Kack",
            email: "jack@gmail.com",
            IM: {
                "label": "telegram",
                "value": "NA"
            },
            createdAt: "24 July, 2026"
        },
        {
            id: "2",
            status: true,
            name: "Mack",
            email: "jack@gmail.com",
            IM: {
                "label": "telegram",
                "value": "NA"
            },
            createdAt: "24 July, 2026"
        },
        {
            id: "3",
            status: true,
            name: "Nack",
            email: "jack@gmail.com",
            IM: {
                "label": "telegram",
                "value": "NA"
            },
            createdAt: "24 July, 2026"
        },
        {
            id: "4",
            status: true,
            name: "Sack",
            email: "jack@gmail.com",
            IM: {
                "label": "telegram",
                "value": "NA"
            },
            createdAt: "24 July, 2026"
        },
        {
            id: "5",
            status: true,
            name: "Tack",
            email: "jack@gmail.com",
            IM: {
                "label": "telegram",
                "value": "NA"
            },
            createdAt: "24 July, 2026"
        }

    ])
    const [loading, setLoading] = useState(true)
    const [initialLoad, setInitialLoad] = useState(true)

    const [page, setPage] = useState({
        current: 1,
        pageSize: 50,
        total: 10,
    });



    const [sort, setSort] = useState({
        name: "",
        type: ""
    });

    const [search, setSearch] = useState("")




    const getData = () => {
        setLoading(true)
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .get(configData.SERVER_URL + `user/usersList?sort=${sort.name}&order=${sort.type}&search=${search}&limit=${page.pageSize}&page=${page.current}`, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    // setData(response.data.data.data)
                    if (response.data.data.data.length > 0) {
                        let tempPage = { ...page }
                        tempPage.total = response.data.data.metaData?.totalRecords

                        setPage(tempPage)
                    }


                    // setTimeout(() => {
                    setLoading(false)
                    // }, 300)
                    setInitialLoad(false)
                })
                .catch((error) => {
                    // setData([])
                    setLoading(false)
                    setInitialLoad(false)
                });
        }

    }

    useEffect(() => {
        TokenVerificationLoggedin();
        BlockOtherThanAdmin()
        // let status = Cookies.get("token_xapads_ssp") ? true : false;
        // if (status) {
        //     let token = Cookies.get("token_xapads_ssp");
        // let checkRole = jwtDecode(token).role;
        // setCheckRole(checkRole)
        // }
        getData()
        loadingContext.done()
    }, [loadingContext]);



    useEffect(() => {
        if (!initialLoad) {
            getData()
        }
    }, [apiCall])

    useEffect(() => {
        if (!initialLoad) {
            const delayDebounceFn = setTimeout(() => {
                let tempPage = page
                tempPage.current = 1
                setPage(tempPage);
                setApicall(!apiCall)
            }, 400); // 500ms delay
            // Cleanup function to clear the timeout if query changes
            return () => clearTimeout(delayDebounceFn);
        }
    }, [search]);



    const handleTableChange = (pagination, filters, sorter) => {
        setSort({ name: sorter.field, type: sorter.order });
        setApicall(!apiCall)
    };

    const handlePageChange = (data) => {

        let tempPage = page
        tempPage.current = data
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const handlePageSizeChange = (e) => {
        let tempPage = page
        tempPage.pageSize = e

        if (tempPage.current > 1) {
            if (e * tempPage.current > tempPage.total) {
                tempPage.current = tempPage.current - 1
            }
        }
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };


    const locale = {
        emptyText:
            <>{search.trim().length > 0 && loading ?
                <div className='no_data_screen'>
                    <div className='text-center'>

                        <div className='float_text_div'>

                        </div>
                    </div>
                </div>
                :
                search.trim().length > 0 && !loading ?
                    <div className='no_data_screen'>
                        <div className='text-center'>
                            <img src={errorData} className='' alt="" />
                            <div className='float_text_div'>

                            </div>
                        </div>
                    </div>
                    :

                    loading ?
                        <div className='no_data_screen'>
                            <div className='text-center'>

                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
                        :
                        <div className='no_data_screen' >
                            <div className='text-center'>
                                <img src={noData} className='' alt="" />
                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
            }
            </>

    };


    ///--------------------------user create modal related code ----------------------------
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setEmailRegister("")
        setEmailRegisterIsRequiredError(false)
        setEmailRegisterUrlError(false)
        setIm("")
        setImIsRequiredError(false)
        setSelectedIm("telegram")
        setName("")
        setNameIsRequiredError(false)
        setButtonValue(false)
    };

    const [emailRegister, setEmailRegister] = useState("");
    const [emailRegisterIsRequiredError, setEmailRegisterIsRequiredError] = useState(false);
    const [emailRegisterUrlError, setEmailRegisterUrlError] = useState(false);

    const [im, setIm] = useState("");
    const [imIsRequiredError, setImIsRequiredError] = useState(false);

    const [selectedIm, setSelectedIm] = useState("telegram");

    const [name, setName] = useState("");
    const [nameIsRequiredError, setNameIsRequiredError] = useState(false);

    const [buttonValue, setButtonValue] = useState(false);

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    function onChangeName(event) {
        setNameIsRequiredError(false);
        setName(event.target.value);
    }

    function onBlurName(event) {
        if (event.target.value.trim().length === 0) {
            setNameIsRequiredError(true);
        }
        setName(event.target.value.trim());
    }


    function onChangeEmailRegister(event) {
        setEmailRegisterIsRequiredError(false);
        setEmailRegister(event.target.value);

        if (validateEmail(event.target.value) === null) {
            setEmailRegisterUrlError(true);
        } else {
            setEmailRegisterUrlError(false);
        }
    }

    function onBlurEmailRegister(event) {
        if (event.target.value.trim().length === 0) {
            setEmailRegisterUrlError(false);
            setEmailRegisterIsRequiredError(true);
        }
        else {
            if (validateEmail(event.target.value.trim()) === null) {
                setEmailRegisterUrlError(true);
            } else {
                setEmailRegisterUrlError(false);
            }
        }
        setEmailRegister(event.target.value.trim());
    }


    function onChangeIm(event) {
        setImIsRequiredError(false);
        setIm(event.target.value);
    }

    function onBlurIm(event) {
        if (event.target.value.trim().length === 0) {
            setImIsRequiredError(true);
        }
        setIm(event.target.value.trim())
    }

    function onChangeSelectedIm(event) {
        setSelectedIm(event);
    }

    const handleSubmitModal = async (e) => {
        e.preventDefault();
        if (
            name !== "" &&
            emailRegister !== "" &&
            im !== ""
        ) {
            if (
                nameIsRequiredError === false &&
                emailRegisterIsRequiredError === false &&
                emailRegisterUrlError === false &&
                imIsRequiredError === false
            ) {
                let payload = {
                    p_name: name,
                    email: emailRegister,
                    im: { "label": selectedIm, "value": im }
                };

                setButtonValue(true);

                axios
                    .post(configData.SERVER_URL + "user/create123", payload)
                    .then((response) => {

                        notifysuccess(response.data.message);
                        handleCancel()
                        setApicall(!apiCall)
                    })
                    .catch((error) => {
                        if (error?.response) {
                            if (error?.response?.data?.message?.length !== 0) {
                                notifyfailure(error.response.data.message)
                            }
                        } else {
                            notifycatch()
                        }
                        setButtonValue(false);
                    });
            }
        } else {
            if (name === "") {
                setNameIsRequiredError(true);
            }
            if (emailRegister === "") {
                setEmailRegisterIsRequiredError(true);
            }
            if (im === "") {
                setImIsRequiredError(true);
            }
        }
    };

    return (
        <>


            <div className="container_box--wrapper pt_header"
            >
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <h1 className="heading fw_600">
                        User List
                    </h1>

                </div>

                <div className={data.length > 0 ? "table_and_filter_div --without_filter_div half_table_width" : "table_and_filter_div --without_filter_div --no_data_div_height half_table_width"}>
                    <div className="table_area_div">
                        <div className="searchbar_with_btns">
                            <div className="d_flex justify_content_between">
                                <div className="form_content_block--group">
                                    {!initialLoad &&
                                        <Input
                                            type='text'
                                            className='form_control basic md search_input w_table_search'
                                            placeholder="Search"
                                            value={search}
                                            onChange={(e) => {

                                                if (e.target.value.trim().length === 0) {
                                                    setLoading(true)
                                                }

                                                setSearch(e.target.value)
                                            }}
                                        />
                                    }
                                </div>
                                <button className='btn btn_primary w_fit_content md' onClick={showModal}>
                                    <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M8 3.33334V12.6667" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M3.33325 8H12.6666" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        Add New User
                                    </span>
                                </button>
                                {/* <div className="custom_filter_design_d2">
                                <div className="column_hide_unhide_d2">
                                    <Dropdown className="" autoClose="outside">
                                        <Dropdown.Toggle id="dropdown-autoclose-outside">
                                            <img src={columnIcon} alt="" />
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            <div className="colunm_checkbox">
                                                <ul className="p-0 m-0">

                                                    <li>
                                                        <label htmlFor="oneone">
                                                            <input className="form-check-input" type="checkbox" id="oneone"
                                                                checked={colvis.z_cate}
                                                                onChange={() => {
                                                                    let tempData = { ...colvis }
                                                                    tempData.z_cate = !tempData.z_cate
                                                                    setColvis(tempData)
                                                                }}
                                                            /> <span>Category</span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label htmlFor="twotwo">
                                                            <input className="form-check-input" type="checkbox" id="twotwo"
                                                                checked={colvis.invent_type}
                                                                onChange={() => {
                                                                    let tempData = { ...colvis }
                                                                    tempData.invent_type = !tempData.invent_type
                                                                    setColvis(tempData)
                                                                }}
                                                            /> <span>Inventory Type</span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label htmlFor="three">
                                                            <input className="form-check-input" type="checkbox" id="three"
                                                                checked={colvis.p_name}
                                                                onChange={() => {
                                                                    let tempData = { ...colvis }
                                                                    tempData.p_name = !tempData.p_name
                                                                    setColvis(tempData)
                                                                }}
                                                            /> <span>Publisher</span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label htmlFor="four">
                                                            <input className="form-check-input" type="checkbox" id="four"
                                                                checked={colvis.createdAt}
                                                                onChange={() => {
                                                                    let tempData = { ...colvis }
                                                                    tempData.createdAt = !tempData.createdAt
                                                                    setColvis(tempData)
                                                                }}
                                                            /> <span>Created At</span>
                                                        </label>
                                                    </li>

                                                </ul>
                                            </div>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div> */}

                            </div>
                        </div>
                        <div className="table_content--box --new_layout_table_design table_empty_screen_d2">
                            {loading && !initialLoad &&
                                <div className="table_new_loader_d2">
                                    <img src={FullLoader} className="img-fluid" alt="" />
                                </div>
                            }

                            {initialLoad ?
                                <TableLoader />

                                :
                                <Table
                                    columns={columnsAll}
                                    pageSize={100}
                                    dataSource={data}
                                    onChange={handleTableChange}
                                    pagination={false}
                                    rowKey={(record) => record.id}
                                    locale={locale}
                                    scroll={{ y: 'calc(100vh - 30.9rem' }} />


                            }

                            {data.length > 0 &&
                                <Row className="custom_pagination--container">
                                    <Col span={6}>
                                        <div className="form_content_block--group mb_0">
                                            <Select
                                                className='form_select basic sm no_search'
                                                value={page.pageSize}
                                                onChange={handlePageSizeChange}
                                                style={{ width: 80 }}
                                                showSearch={false}
                                                options={[
                                                    { value: 10, label: 10 },
                                                    { value: 20, label: 20 },
                                                    { value: 50, label: 50 },
                                                    { value: 100, label: 100 },
                                                ]} />
                                            <label className='custom_pagination--label'>
                                                items per page
                                            </label>
                                        </div>
                                    </Col>
                                    <Col span={6}>
                                        <span className="custom_pagination--total-text">
                                            {`${(page.current - 1) * page.pageSize + 1}-${Math.min(page.current * page.pageSize, page.total)} of ${page.total} items`}
                                        </span>
                                    </Col>
                                    <Col span={6}>
                                        <Pagination
                                            current={page.current}  // Pass individual props instead of spreading them
                                            pageSize={page.pageSize}
                                            total={page.total}
                                            onChange={handlePageChange}
                                            showSizeChanger={false}
                                            itemRender={itemRender}
                                            className="custom_pagination" />
                                    </Col>
                                </Row>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                className='custom_modal custom_modal_form_d2'
                title={
                    <div className='custom_modal--header'><h3 className='heading'>
                        <img src={AddUserIcon} alt='USP' /> Add New User</h3>
                    </div>
                }
                width={780}
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={isModalOpen}
                onCancel={handleCancel}
                maskClosable={false}
                footer={[
                    <div className="custom_modal--footer d_flex justify_content_end publisher_domain_upload_footer gap_8">
                        <div className="d_flex justify_content_start align_items_center">
                            <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                onClick={handleCancel}
                                disabled={buttonValue}
                            >Discard</button>
                        </div>

                        <div className="btn_group justify-content-end gap_8">
                            {buttonValue ?
                                <button
                                    className="w_120_d2 btn btn_primary w_fit_content loader"

                                >
                                    <span>Create Zone</span>

                                    <img
                                        src={loaderIcon}
                                        alt="USP"
                                        className="loader_icon"
                                    />
                                </button>
                                :
                                <button className="w_120_d2 btn btn_primary w_fit_content" onClick={handleSubmitModal}>Create User</button>
                            }
                        </div>
                    </div>
                ]}>
                <div className="custom_tabs_wrapper">


                    {/* Tabs content */}
                    <div className="custom_tab_content --custom_tab_content_form-div">
                        <div>
                            <div className="custom_modal--body">
                                <div className="tab_content--body">
                                    {/* <div className="form_content_block--group modal_form_bottom_gap_d2">
                                        <label className="form_label">Publisher *</label>
                                        <Select
                                            showSearch={true}
                                            optionLabelProp="label"
                                            className='form_select basic'
                                            placeholder="-Select-">
                                            <Option value="Video">Video</Option>
                                            <Option value="Banner">Banner</Option>

                                        </Select>
                                    </div> */}
                                    <div className="form_content_block--group modal_form_bottom_gap_d2">
                                        <Row gutter={20}>
                                            <Col span={12}>
                                                <label className="form_label">User Full Name *</label>
                                                <Input

                                                    className="form_control basic"
                                                    // className={
                                                    //     nameIsRequiredError
                                                    //         ? "form_control basic error"
                                                    //         : "form_control basic"
                                                    // }
                                                    placeholder="Enter User Full Name"
                                                    autocomplete="off"
                                                    value={name}
                                                    onBlur={onBlurName}
                                                    onChange={onChangeName}
                                                />
                                                {nameIsRequiredError && (
                                                    <span className="error_content h_error">

                                                        <> This field is required</>
                                                    </span>
                                                )}

                                            </Col>
                                            <Col span={12}>
                                                <label className="form_label">Organization Name *</label>
                                                <Input
                                                    className="form_control basic"
                                                    // className={
                                                    //     nameIsRequiredError
                                                    //         ? "form_control basic error"
                                                    //         : "form_control basic"
                                                    // }
                                                    disabled
                                                    placeholder="Organization Name"
                                                    autocomplete="off"
                                                // value={name}
                                                // onBlur={onBlurName}
                                                // onChange={onChangeName}
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="form_content_block--group modal_form_bottom_gap_d2 mb-0">
                                        <Row gutter={20}>
                                            <Col span={12}>
                                                <label className="form_label">Email ID *</label>
                                                <Input
                                                    // className={
                                                    //     (emailRegisterIsRequiredError || emailRegisterUrlError)
                                                    //         ? "form_control basic error"
                                                    //         : "form_control basic"
                                                    // }
                                                    className="form_control basic"
                                                    placeholder="Enter Email ID"
                                                    autocomplete="off"
                                                    value={emailRegister}
                                                    onBlur={onBlurEmailRegister}
                                                    onChange={onChangeEmailRegister}
                                                />
                                                {emailRegisterIsRequiredError && (
                                                    <span className="error_content h_error">
                                                        <> This field is required</>
                                                    </span>
                                                )}

                                                {emailRegisterUrlError && (
                                                    <span className="error_content h_error">
                                                        <> Invalid Email Address</>
                                                    </span>
                                                )}
                                            </Col>
                                            <Col span={12}>
                                                <div className="form_content_block--group">
                                                    <label className="form_label">IM * </label>
                                                    <Space.Compact className='form_compact'>
                                                        <Select
                                                            popupMatchSelectWidth={true}
                                                            className='form_select'
                                                            value={selectedIm}
                                                            onChange={onChangeSelectedIm}
                                                            options={constantData.IM_OPTIONS}

                                                        />
                                                        <Input
                                                            className="form_control basic"
                                                            value={im}
                                                            placeholder="Username"
                                                            onChange={onChangeIm}
                                                            onBlur={onBlurIm}
                                                            autocomplete="off"
                                                        />
                                                    </Space.Compact>
                                                    {imIsRequiredError && (
                                                        <span className="error_content h_error">
                                                            <> This field is required</>
                                                        </span>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default PublisherUserList;
